import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const SmartExpiryRadar = ({ variant = 'full' }) => {
  const navigate = useNavigate();
  const [radarData, setRadarData] = useState({
    expired: 0,
    expiringSoon: 0,
    upcoming: 0,
    valid: 0,
  });

  useEffect(() => {
    setRadarData({
      expired: 3,
      expiringSoon: 7,
      upcoming: 12,
      valid: 45,
    });
  }, []);

  const handleNavigate = (filter) => {
    navigate('/smart-certificate-expiry-management', { state: { filter } });
  };

  const total = radarData?.expired + radarData?.expiringSoon + radarData?.upcoming + radarData?.valid;

  const radarItems = [
    {
      label: 'Expired',
      count: radarData?.expired,
      color: 'var(--color-error)',
      bgColor: 'rgba(230, 57, 70, 0.1)',
      icon: 'AlertCircle',
      filter: 'expired',
    },
    {
      label: 'Expiring Soon',
      count: radarData?.expiringSoon,
      color: 'var(--color-warning)',
      bgColor: 'rgba(244, 162, 97, 0.1)',
      icon: 'Clock',
      filter: 'expiring-soon',
    },
    {
      label: 'Upcoming',
      count: radarData?.upcoming,
      color: 'var(--color-accent)',
      bgColor: 'rgba(45, 156, 219, 0.1)',
      icon: 'Calendar',
      filter: 'upcoming',
    },
    {
      label: 'Valid',
      count: radarData?.valid,
      color: 'var(--color-success)',
      bgColor: 'rgba(42, 157, 143, 0.1)',
      icon: 'CheckCircle',
      filter: 'valid',
    },
  ];

  if (variant === 'summary') {
    return (
      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-foreground font-heading">Certificate Status</h3>
          <button
            onClick={() => navigate('/smart-certificate-expiry-management')}
            className="text-sm text-accent hover:underline font-caption"
          >
            View All
          </button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {radarItems?.map((item) => (
            <button
              key={item?.label}
              onClick={() => handleNavigate(item?.filter)}
              className="p-4 rounded-lg border border-border transition-smooth hover:border-accent"
              style={{ backgroundColor: item?.bgColor }}
            >
              <div className="flex items-center gap-2 mb-2">
                <Icon name={item?.icon} size={16} color={item?.color} />
                <span className="text-xs text-muted-foreground font-caption">{item?.label}</span>
              </div>
              <p className="text-2xl font-semibold font-heading" style={{ color: item?.color }}>
                {item?.count}
              </p>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 className="text-2xl font-semibold text-foreground mb-6 font-heading">Smart Certificate Expiry Radar</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {radarItems?.map((item) => (
          <button
            key={item?.label}
            onClick={() => handleNavigate(item?.filter)}
            className="p-6 rounded-lg border border-border transition-smooth hover:border-accent hover:shadow-warm-md"
            style={{ backgroundColor: item?.bgColor }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="h-12 w-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: item?.bgColor }}>
                <Icon name={item?.icon} size={24} color={item?.color} />
              </div>
              <div className="text-right">
                <p className="text-3xl font-bold font-heading" style={{ color: item?.color }}>
                  {item?.count}
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  {((item?.count / total) * 100)?.toFixed(0)}%
                </p>
              </div>
            </div>
            <p className="text-sm font-medium text-foreground font-caption">{item?.label}</p>
          </button>
        ))}
      </div>
      <div className="relative h-64 bg-input rounded-lg p-6">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative">
            <svg width="200" height="200" viewBox="0 0 200 200">
              <circle
                cx="100"
                cy="100"
                r="80"
                fill="none"
                stroke="var(--color-border)"
                strokeWidth="20"
              />
              <circle
                cx="100"
                cy="100"
                r="80"
                fill="none"
                stroke="var(--color-success)"
                strokeWidth="20"
                strokeDasharray={`${(radarData?.valid / total) * 502.65} 502.65`}
                strokeDashoffset="0"
                transform="rotate(-90 100 100)"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <p className="text-4xl font-bold text-foreground font-heading">{total}</p>
              <p className="text-sm text-muted-foreground font-caption">Total Certificates</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartExpiryRadar;